module.exports = __webpack_public_path__ + "img/l-cb6-000.ed16396e.gif";